import { motion, useReducedMotion } from "framer-motion";

// Reveal: animación de aparición al hacer scroll. Respeta movimiento reducido.
export function Reveal({ children, className, delay = 0 }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Encabezado de sección: las clases usan el prefijo de cada plantilla (p),
// así los estilos quedan aislados por diseño.
export function EncabezadoSeccion({ p = "we", etiqueta, titulo, centro = false, testid }) {
  return (
    <Reveal className={centro ? `${p}-encabezado ${p}-encabezado--centro` : `${p}-encabezado`}>
      {etiqueta && <p className={`${p}-etiqueta`}>{etiqueta}</p>}
      <h2 className={`${p}-titulo-seccion`} data-testid={testid}>
        {titulo}
      </h2>
      <span className={`${p}-regla`} />
    </Reveal>
  );
}

// Marquesina editorial lenta. Requiere en el CSS de la plantilla:
// .{p}-marquee, .{p}-marquee-pista (con @keyframes {p}-marquee) y .{p}-marquee-item
export function Marquee({ p = "we", textos }) {
  const grupo = (clave) => (
    <div style={{ display: "flex" }} aria-hidden="true" key={clave}>
      {textos.map((t, i) => (
        <span className={`${p}-marquee-item`} key={`${clave}-${i}`}>
          {t}
        </span>
      ))}
    </div>
  );
  return (
    <div className={`${p}-marquee`} data-testid={`${p}-marquee`}>
      <div className={`${p}-marquee-pista`}>
        {grupo("a")}
        {grupo("b")}
      </div>
    </div>
  );
}
